"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = exports.ActionIcon = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _styledTools = require("styled-tools");

var _icons = require("../icons");

var _IconButton = require("../IconButton");

var ActionIcon = (0, _stylitas.styled)(_icons.Close)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  width: 24px;\n  height: 24px;\n\n  ", "\n"])), (0, _styledTools.theme)('colorIconNeutral90'), _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 32px;\n    height: 32px;\n  "]))));
exports.ActionIcon = ActionIcon;
var StyledIconButton = (0, _stylitas.styled)(_IconButton.IconButton)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-self: flex-end;\n"])));
exports.IconButton = StyledIconButton;